<template>
    <div v-if="isDirectAdmin(subscription)" class="page-block__item-wrapper">
        <h3>{{ trans('hosting.information-title') }}</h3>

        <subscription-username v-if="subscription.username" :username="subscription.username" />

        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/3-desk">
                        <span class="page-block__item-content-title">
                            {{ trans('hosting.settings.reset-passwords-password') }}
                        </span>
                    </div>
                    <!--
                 -->
                    <div class="layout__item u-2/3-desk">
                        {{ password }}
                    </div>
                </div>
            </div>
            <div class="page-block__item-nav">
                <button @click="showResetModal" type="button" class="btn btn--ghost btn--ghost-full-width">
                    {{ trans('hosting.settings.reset-passwords') }}
                </button>
            </div>
        </div>

        <subscription-ftps-host v-if="subscription.ftps_host" :ftpsHost="subscription.ftps_host" />

        <reset-modal v-if="resetModalVisible" @close="closeResetModal" :domain="domain" :username="subscription.username" />
    </div>
</template>

<script>
import ResetModal from './ResetModal.vue';
import { SubscriptionFtpsHost, SubscriptionUsername } from 'relapp-technical-management';

export default {
    components: {
        ResetModal,
        SubscriptionFtpsHost,
        SubscriptionUsername
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            resetModalVisible: false,
            password: '---'
        };
    },
    methods: {
        /**
         * Show the modal to login to Plesk.
         */
        showResetModal() {
            this.resetModalVisible = true;
        },

        /**
         * Close the modal.
         */
        closeResetModal() {
            this.resetModalVisible = false;
        },

        isDirectAdmin(subscription) {
            return subscription.hosting_provider === "directadmin";
        }
    }
};
</script>
